import React from 'react';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
    Row,
    RightComponents,
    LeftComponents,
} from '../../components/Layout';
import {
    Button,
    MultiSelectBox,
    SearchBox,
} from '../../components/Form';
import {
    TableData,
    TableHeader,
    TableBody,
    TableRow,
    TableColumn,
} from '../../components/Table';
import {
    MobileInfoBox,
    Title,
    TextView,
    PanelBox,
    Modal,
} from '../../components/Display';
import { postData } from '../../Api';
import TaroffSupportRequestView from './TaroffSupportRequestView';

export default function TaroffSupportRequests(props) {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [modal, setModal] = useState(null);
    const allProps = { ...props, ...Object.fromEntries(searchParams.entries()) };
    const handleCreateNewRequest = () => {
        console.log('button-data-create');
    };
    const [formQShopIdOptions, setFormQShopIdOptions] = useState([]);
    useEffect(() => {
        postData('/api/panel/page/taroff-support-requests/select-data/q-shop-id').then(
            (response) => {
                setFormQShopIdOptions(response.data);
            }
        );
    }, []);
    const [formQTypeIdOptions, setFormQTypeIdOptions] = useState([]);
    useEffect(() => {
        postData('/api/panel/page/taroff-support-requests/select-data/q-type-id').then(
            (response) => {
                setFormQTypeIdOptions(response.data);
            }
        );
    }, []);
    const [formQStateIdOptions, setFormQStateIdOptions] = useState([]);
    useEffect(() => {
        postData('/api/panel/page/taroff-support-requests/select-data/q-state-id').then(
            (response) => {
                setFormQStateIdOptions(response.data);
            }
        );
    }, []);
    const [summary, setSummary] = useState({});
    useEffect(() => {
        postData('/api/panel/page/taroff-support-requests/summary').then((response) => {
            setSummary(response.data || {});
        });
    }, [searchParams, modal]);
    const filterQBucket = allProps['q-bucket'] || '';
    const setBucket = (bucket) => {
        const params = { ...Object.fromEntries(searchParams.entries()) };
        if (bucket) params['q-bucket'] = bucket; else delete params['q-bucket'];
        delete params['page'];
        navigate({ search: '?' + new URLSearchParams(params).toString() });
    };
    const [tableData, setTableData] = useState({});
    const [tableSize, setTableSize] = useState(parseInt(allProps['size']) || 20);
    const [tablePage, setTablePage] = useState(parseInt(allProps['page']) || 1);
    const gotoPage = (page, size = undefined) => {
        setTableData({});
        setTablePage(page);
        size && setTableSize(size);
        setSearchParams({ ...searchParams, page: page, size: size || tableSize });
    };
    const clearFilters = () => {
        setFilterQShopId('');
        setFilterQTypeId('');
        setFilterQStateId('');
        setFilterQTitle('');
        setSearchParams({});
    };
    const applyFilters = () => {
        const newSearchParams = {};
        filterQShopId && (newSearchParams['q-shop-id'] = filterQShopId);
        filterQTypeId && (newSearchParams['q-type-id'] = filterQTypeId);
        filterQStateId && (newSearchParams['q-state-id'] = filterQStateId);
        filterQTitle && (newSearchParams['q-title'] = filterQTitle);
        navigate({ search: '?' + new URLSearchParams(newSearchParams).toString() });
    };
    const [filterQShopId, setFilterQShopId] = useState(allProps['q-shop-id'] || '');
    const [filterQTypeId, setFilterQTypeId] = useState(allProps['q-type-id'] || '');
    const [filterQStateId, setFilterQStateId] = useState(allProps['q-state-id'] || '');
    const [filterQTitle, setFilterQTitle] = useState(allProps['q-title'] || '');
    useEffect(() => {
        postData('/api/panel/page/taroff-support-requests/table-data', {
            size: tableSize,
            page: tablePage,
            q_shop_id: filterQShopId,
            q_type_id: filterQTypeId,
            q_state_id: filterQStateId,
            q_title: filterQTitle,
            q_bucket: filterQBucket,
        }).then((response) => {
            setTableData(response.data);
        });
    }, [searchParams, modal, props]);
    const handleViewRequest = (row) => {
        setModal(
            Modal({
                children: (
                    <TaroffSupportRequestView
                        support-request-id={row.text_id}
                        onDismiss={() => setModal(null)}
                    />
                ),
                onDismiss: () => setModal(null),
                width: '820px',
            })
        );
    };
    const handleQuickToggleState = async (row, e) => {
        e && e.stopPropagation && e.stopPropagation();
        const key = row.text_state_id_key === 'Closed' ? 'Opened' : 'Closed';
        await postData('/api/panel/page/taroff-support-request-state-by-key/save', { id: row.text_id, key });
        setSearchParams({ ...Object.fromEntries(searchParams.entries()) });
    };
    return (
        <PanelBox>
            <Row>
                <RightComponents>
                    <Title>درخواست ها</Title>
                </RightComponents>
                <LeftComponents>
                    <Button onClick={handleCreateNewRequest} color={'secondary'}>
                        ایجاد درخواست
                    </Button>
                </LeftComponents>
            </Row>
            <div className="flex flex-wrap gap-2 mb-4">
                {[
                    { key: '', label: 'همه', count: summary.total },
                    { key: 'awaiting_admin', label: 'منتظر پاسخ ما', count: summary.awaiting_admin, highlight: true },
                    { key: 'open', label: 'باز', count: summary.open },
                    { key: 'closed', label: 'بسته شده', count: summary.closed },
                ].map((chip) => {
                    const active = filterQBucket === chip.key;
                    const danger = chip.highlight && chip.count > 0;
                    return (
                        <button
                            key={chip.key || 'all'}
                            onClick={() => setBucket(chip.key)}
                            className={`flex items-center gap-2 rounded-full px-4 py-1.5 text-sm font-medium border transition-colors ${
                                active
                                    ? 'bg-gray-900 text-white border-gray-900 dark:bg-white dark:text-gray-900 dark:border-white'
                                    : danger
                                        ? 'bg-red-50 text-red-700 border-red-200 dark:bg-red-950 dark:text-red-300 dark:border-red-800'
                                        : 'bg-white text-gray-700 border-gray-200 hover:bg-gray-50 dark:bg-gray-900 dark:text-gray-300 dark:border-gray-700 dark:hover:bg-gray-800'
                            }`}
                        >
                            <span>{chip.label}</span>
                            <span className={`min-w-[20px] rounded-full px-1.5 text-xs font-bold ${active ? 'bg-white/20' : danger ? 'bg-red-600 text-white' : 'bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-200'}`}>
                                {(chip.count ?? 0).toLocaleString('fa-IR')}
                            </span>
                        </button>
                    );
                })}
            </div>
            <RightComponents wrap={true}>
                <MultiSelectBox
                    label={'فروشگاه'}
                    options={formQShopIdOptions}
                    value={filterQShopId}
                    onChange={setFilterQShopId}
                />
                <MultiSelectBox
                    label={'نوع درخواست'}
                    options={formQTypeIdOptions}
                    value={filterQTypeId}
                    onChange={setFilterQTypeId}
                />
                <MultiSelectBox
                    label={'وضعیت درخواست'}
                    options={formQStateIdOptions}
                    value={filterQStateId}
                    onChange={setFilterQStateId}
                />
                <SearchBox onEnter={applyFilters}
                    label={'عنوان'}
                    value={filterQTitle}
                    onChange={setFilterQTitle}
                    width={'120px'}
                />
                <Button rightIcon={'far fa-search'} onClick={applyFilters}>
                    جستجو
                </Button>
                <Button rightIcon={'far fa-trash'} onClick={clearFilters}>
                    پاک کردن
                </Button>
            </RightComponents>
            <TableData total={tableData.total} size={tableSize} page={tablePage} setPage={gotoPage}>
                <TableHeader>
                    <TableRow>
                        <TableColumn mobile={true}>mobile</TableColumn>
                        <TableColumn mobile={false}>شناسه</TableColumn>
                        <TableColumn mobile={false}>عنوان</TableColumn>
                        <TableColumn mobile={false}>فروشگاه</TableColumn>
                        <TableColumn mobile={false}>وضعیت</TableColumn>
                        <TableColumn mobile={false}>نوع</TableColumn>
                        <TableColumn mobile={false}>زمان ایجاد</TableColumn>
                        <TableColumn mobile={false}></TableColumn>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {tableData.rows?.map((row, index) => (
                        <TableRow key={index}>
                            <TableColumn mobile={true}>
                                <MobileInfoBox />
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView>{row.text_id}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView bold={true}>{row.text_title}</TextView>
                                {row.flag_awaiting_admin && (
                                    <span className="inline-flex items-center gap-1 mt-1 rounded-full bg-red-50 text-red-700 border border-red-200 px-2 py-0.5 text-xs font-medium dark:bg-red-950 dark:text-red-300 dark:border-red-800">
                                        <i className="far fa-reply"></i>
                                        منتظر پاسخ ما
                                    </span>
                                )}
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView backColor={row.color_shop_id_color}>
                                    {row.text_shop_id_title}
                                </TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView backColor={row.color_state_id_color}>
                                    {row.text_state_id_title}
                                </TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView backColor={row.color_type_id_color}>
                                    {row.text_type_id_title}
                                </TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView format={'persian-date-normal'}>
                                    {row.text_inserttime}
                                </TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <LeftComponents>
                                    <Button
                                        onClick={() => handleViewRequest(row)}
                                        color={'primary'}
                                        rightIcon={'far fa-comments'}
                                        tooltip={'مشاهده و پاسخ'}
                                    >
                                        پاسخ
                                    </Button>
                                    <Button
                                        onClick={(e) => handleQuickToggleState(row, e)}
                                        color={row.text_state_id_key === 'Closed' ? 'accent' : 'warn'}
                                        rightIcon={row.text_state_id_key === 'Closed' ? 'far fa-rotate-right' : 'far fa-check'}
                                        tooltip={row.text_state_id_key === 'Closed' ? 'بازکردن مجدد' : 'بستن درخواست'}
                                    ></Button>
                                </LeftComponents>
                            </TableColumn>
                        </TableRow>
                    ))}
                </TableBody>
            </TableData>
            {modal && modal}
        </PanelBox>
    );
}
